export const API_CONFIG = {
  INTERNAL_COMMUNICATION: {
    path: "internal-communication",
    queryKey: "internal-communication",
  },
  FEEDBACK: {
    path: "feedback",
    queryKey: "feedback",
  },
  CUSTOMER_PROPERTY: {
    path: "customer-property",
    queryKey: "customer-property",
  },
  WORK_ENVIRONMENT: {
    path: "work-environment",
    queryKey: "work-environment",
  },
  MAM_OF_EQUIPMENT: {
    path: "monitoring-and-measurement-of-equipment",
    queryKey: "monitoring-and-measurement-of-equipment",
  },
  COD: {
    path: "cod",
    queryKey: "cod",
  },
  CUSTOMER_SERVICE: {
    path: "customer-service",
    queryKey: "customer-service",
  },
  MONITORING_AND_MEASURING_OF_PRODUCT: {
    path: "monitoring-and-measuring-of-product",
    queryKey: "monitoring-and-measuring-of-product",
  },
  MONITORING_AND_MEASURING_OF_PRODUCT_SAMPLING_PLAN: {
    path: "monitoring-and-measuring-of-product/sampling-plan",
    queryKey: "monitoring-and-measuring-of-product/sampling-plan",
  },
  CONTROL_OF_RECORD: {
    path: "control-of-records",
    queryKey: "control-of-records",
  },
  MAM_OF_EQUIPMENT: {
    path: "monitoring-and-measurement-of-equipment",
    queryKey: "monitoring-and-measurement-of-equipment",
  },

  MONITORING_AND_MEASURING_OF_PRODUCT_RAW_MATERIAL: {
    path: "pd/raw-materials",
    queryKey: "pd/raw-materials",
  },
  CONTROL_OF_NON_CONFIRMING: {
    path: "control-of-non-confirming",
    queryKey: "control-of-non-confirming",
  },
  CUSTOMER_COMPLAINT: {
    path: "customer-complaints",
    queryKey: "customerComplaint",
  },
  PREVENTIVE_MAINTENANCE: {
    path: "preventive-maintenance",
    queryKey: "preventive-maintenance",
  },
  MRM: {
    path: "mrm-new",
    queryKey: "mrm-new",
  },
  IQA: {
    path: "iqa-new",
    queryKey: "iqa-new",
  },
  PROCESS_VALIDATIONS: {
    path: "process-validation",
    queryKey: "process-validation",
    parts: [
      {
        queryKey: "pro-format",
        title: "pro-format",
        url: "pro-format",
      },
      {
        queryKey: "format",
        title: "format",
        url: "format",
      },
    ],
  },
  CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTOR: {
    path: "customer-related-process-and-distribution-new",
    queryKey: "customer-related-process-and-distributor",
    parts: [
      {
        queryKey: "order",
        title: "Order",
        url: "order",
      },
      {
        queryKey: "distributor",
        title: "Distributor",
        url: "distributor",
      },
    ],
  },
  PRODUCT_DESCRIPTION: {
    path: "pd",
    queryKey: "pd",
    parts: [
      {
        queryKey: "product-list",
        title: "Product List",
        url: "product-list",
      },
      {
        queryKey: "product-additional-description",
        title: "Product Additional Description",
        url: "product-additional-description",
      },
    ],
  },
  CAT_FORMAT: {
    path: "cat-dynamic",
    queryKey: "cat-dynamic",
  },
  CAT_TRANNING: {
    path: "training",
    queryKey: "training",
  },
  PREVENTIVE_ACTION: {
    path: "preventive-action",
    queryKey: "preventive-action",
  },
  CORRECTIVE_ACTION: {
    path: "corrective-action",
    queryKey: "corrective-action",
  },
  INSTALLATION: {
    path: "installation",
    queryKey: "installation",
  },
  ADVISORY_NOTICE: {
    path: "advisory-notice-and-recall",
    queryKey: "advisory-notice-and-recall",
    parts: [
      {
        queryKey: "notice",
        title: "Notice",
        url: "notice",
      },
      {
        queryKey: "format",
        title: "Format",
        url: "format",
      },
    ],
  },

  PURCHASE: {
    path: "purchase-reborn",
    queryKey: "purchase-reborn",
  },

  PURCHASE_STOCK: {
    path: "purchase-stock",
    queryKey: "purchase-stock",
  },
  COMMUNICATION_WITH_REGULATORY_BODIES: {
    path: "communication-with-regulatory-bodies",
    queryKey: "communication-with-regulatory-bodies",
  },
  CWRB_PENDING: {
    path: "cwrb-pending",
    queryKey: "cwrb-pending",
  },
  PRODUCTION: {
    path: "production-new",
    queryKey: "production-new",
    parts: [
      {
        queryKey: "format",
        title: "Format",
        url: "format",
      },
      {
        queryKey: "bmr",
        title: "BMR",
        url: "bmr",
      },
      {
        queryKey: "stock-register",
        title: "Stock-Register",
        url: "stock-register",
      },
    ],
  },
};
